import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import { Fragment } from 'react'

type Props = {
  isOpen: boolean
  message: string
  variant?: 'success' | 'error'
  topMost?: boolean
}

export const Alert = ({
  isOpen,
  message,
  variant = 'error',
  topMost = false,
}: Props) => {
  const classes = classNames(
    'fixed z-20 top-20 left-1/2 transform -translate-x-1/2 max-w-sm pointer-events-auto overflow-hidden',
    'px-7 py-4 rounded-2xl shadow-[0_12px_32px_rgba(0,0,0,0.25)]',
    {
      'bg-clash-red text-white': variant === 'error',
      'bg-clash-blue text-white': variant === 'success',
    }
  )

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="ease-out duration-300 transition"
      enterFrom="opacity-0 translate-y-2"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-2"
    >
      <div className={classes}>
        <p className="text-center text-base font-semibold">{message}</p>
      </div>
    </Transition>
  )
}
